import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { getRequestIns } from '../requestIns';
export const useSoldOutPopupStore = defineStore('soldOutPopup', {
    actions: {
        /**
         * 查询组合包单项弹窗详情
         * @param params
         */
        async getGenerationSoldOutPopup(params) {
            try {
                const result = await configRequest(getRequestIns()).generationSoldOutPopup(params, {
                    showToast: true,
                });
                return result?.data ?? null;
            }
            catch (error) {
                return null;
            }
        },
    },
});
